import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreatePickupRequest from "../Pages/CreatePickupRequest";
import EditPickupRequest from "../Pages/EditPickupRequest";
import PickupRequestList from "../Pages/PickupRequestList";
//@ts-ignore
import { AccessControl,PermissionRequired} from "@careinfo/merchant-permission-service";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<PickupRequestList />} />
          <Route path="/edit/:id" element={<EditPickupRequest />} />
          <Route path="/create" element={
            <AccessControl children ={
            <CreatePickupRequest />
            }
            allowedPermissions={["can_create_pickup_request"]}
            />
            } />
         
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
